"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_h5z2gtz9b() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ThreeSixtyVerisonTwo.tsx";
  var hash = "8f15c0234880540cd7ace568ab41cd94b529e5af";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ThreeSixtyVerisonTwo.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8f15c0234880540cd7ace568ab41cd94b529e5af"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_h5z2gtz9b = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_h5z2gtz9b();
var Icon = (cov_h5z2gtz9b().s[0]++, {
  name: '360-2',
  svg: "<path d=\"M8.95652 12.9565C9.11731 13.1977 9.17391 13.3913 9.51055 13.5674C9.19735 13.4628 8.88415 13.4263 8.88415 13.4263C7.65217 13.1739 6.69858 12.8643 5.75213 12.485C5.23013 12.2758 4.81252 12.0666 4.39492 11.5436C4.18612 11.2298 4.08172 10.8114 4.39492 10.393C4.81252 9.97466 5.33453 9.66087 5.85653 9.34708L5.85653 9.34708C7.42254 8.51031 9.30175 8.30112 11.0766 8.19652C12.1206 8.19652 13.0602 8.19652 14.1042 8.30112C15.357 8.40571 16.5054 8.7195 17.6538 9.13789C18.3846 9.45167 19.011 9.76546 19.4286 10.393C19.9506 10.916 19.9506 11.439 19.4286 11.8574C19.1154 12.0666 18.8022 12.3804 18.3846 12.5896C17.7582 12.9033 17.1318 13.1125 16.401 13.3217C16.0878 13.3217 15.7746 13.5309 15.6702 13.6355C15.4614 14.0539 15.4614 14.4723 15.7746 14.8907C16.0878 15.3091 16.5054 15.4137 16.923 15.3091C17.445 15.0999 17.967 14.9953 18.489 14.7861C19.533 14.3677 20.4726 13.8447 21.2034 13.0079C22.2474 11.8574 22.2474 10.2884 21.3078 9.03329C20.6814 8.30112 19.8462 7.77814 19.011 7.35975C17.2362 6.41838 15.2526 6.1046 13.269 6C11.9118 6 10.5546 6 9.19735 6.1046C7.73574 6.31379 6.27413 6.73217 4.91692 7.35975C3.97732 7.77814 3.24651 8.40571 2.62011 9.13789C1.88931 10.1838 1.7849 11.439 2.41131 12.485C2.82891 13.2171 3.55972 13.7401 4.29052 14.2631C5.75213 15.0999 7.28611 15.5734 8.95652 15.7826C9.3913 15.8371 9.6087 15.832 10.0435 15.832L9.71936 16.1458C9.51055 16.355 9.19735 16.5642 8.98855 16.878C8.67535 17.2964 8.77975 17.924 9.19735 18.3424C9.61496 18.7607 10.2414 18.6561 10.659 18.2378L13.0602 15.832C13.5822 15.2045 13.5822 14.5769 13.0602 14.0539L11.4942 12.485L10.5546 11.5436C10.2414 11.2298 9.92816 11.1252 9.51055 11.2298C8.77975 11.439 8.52174 12.3043 8.95652 12.9565Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;